/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Backup_Save_Settings_LabelInputs */



/**
* | output |
* | --- |
* | "Save automatic backup settings" |
*
* @param {Options_Backup_Save_Settings_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_backup_save_settings_label = /** @type {((inputs?: Options_Backup_Save_Settings_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Backup_Save_Settings_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Enregistrer les paramètres de sauvegarde automatique")
	if (locale === "de") return /** @type {LocalizedString} */ ("Automatische Sicherungseinstellungen speichern")
	if (locale === "it") return /** @type {LocalizedString} */ ("Salva le impostazioni di backup automatico")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сохранение настроек автоматического резервного копирования")
	if (locale === "es") return /** @type {LocalizedString} */ ("Guardar la configuración de copia de seguridad automática")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("保存自动备份设置")
	if (locale === "ja") return /** @type {LocalizedString} */ ("自動バックアップ設定を保存する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्वचालित बैकअप सेटिंग्स सहेजें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Salvar configurações de backup automático")
	return /** @type {LocalizedString} */ ("Save automatic backup settings")
});